import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { STAFFID, HISTORY, CATEGORY_ID } from './../../data/constants/';
import MainCardContainer from '../../components/MainCardContainer/';
import CardRow from '../../components/CardRow';
import ListTable from './../../components/ListTable';
import Loader from './../../components/Loader';
import { HISTORY as HISTORY_SETTINGS } from './../../settings/settings';
import * as actions from './../../data/history/actions';
import * as utils from './../../utilities/calendarUtilities.js';
import { useLanguage } from '../../context/LanguageContext';

const History = (props) => {
  const { labels, language } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const HISTORY_LABEL = labels.HISTORY || {};

  const [isFetching, setIsFetching] = useState(true);
  const [closeBids, setCloseBids] = useState([]);

  const buildBidSessions = (bids) => {
    if (!bids) return [];
    return bids.map((bid) => {
      const startDate = language === 'fr' ? utils.formatHistoryDatesInFrench(bid.startDate) : utils.formatHistoryDates(bid.startDate);
      let endDate = utils.removeDays(bid.endDate, 1);
      endDate = language === 'fr' ? utils.formatDateInFrench(endDate) : utils.formatDate(endDate);
      bid = {
        ...bid,
        startDate,
        endDate,
        subtitle: (`${startDate} - ${endDate}`),
        title: bid.name
      };
      return bid;
    });
  };
  const fetchBidSession = (props) => {
    setIsFetching(true);
    const { fetchClosedBidSessions } = props;
    const categoryId = sessionStorage.getItem(CATEGORY_ID);
    if (!categoryId) return;
    let closedBids = [];
    fetchClosedBidSessions(categoryId).then((response) => {
      closedBids = buildBidSessions(response.data.entries);
      setIsFetching(false);
      setCloseBids(closedBids);
    })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    const staffId = sessionStorage.getItem(STAFFID);
    if (staffId !== commonLabels.ADMIN) {
      fetchBidSession(props);
    }
  }, []);

  let closedBid = closeBids;
  closedBid = (closedBid.length !== 0) ?
      closedBid : (<p className="no-reports-message">{HISTORY_LABEL.NO_BIDS_MESSAGE}</p>);
  return (
    <div>
      {
          isFetching ? <Loader /> :
          <MainCardContainer
            headTitle={HISTORY_LABEL.TITLE}
            headSubtitle={HISTORY_LABEL.SUBTITLE}
            content={[
              <CardRow
                key={1}
                cardNumber={1}
                cards={[
                  <ListTable
                    key={1}
                    listItems={closedBid}
                    itemsPerPage={HISTORY_SETTINGS.ITEMS_PER_PAGE}
                    pageRangeDisplayed={HISTORY_SETTINGS.PAGE_RANGE_DISPLAYED}
                  />
                ]}
              />
            ]}
          />
        }
    </div>
  );
};

History.defaultProps = {
  categoryId: {},
  closedBids: {},
  user: {},
};

History.propTypes = {
  fetchClosedBidSessions: PropTypes.func.isRequired,
  categoryId: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = state => ({ ...state.closedBids, categoryId: state.login.user.currentCategory, user: state.login.user });

const mapDispatchToProps = dispatch => ({
  fetchClosedBidSessions: categoryId => dispatch(
    actions.fetchClosedBidSessions(categoryId)
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(History));
